import {
  DataGrid,
  GridPaginationModel,
  GridRowIdGetter,
  GridRowParams,
  GridLocaleText,
  GridSortModel,
} from "@mui/x-data-grid";
import { Grid, makeStyles } from "@material-ui/core";
import CustomPaginationActions from "./CustomPaginationActions";

type Props = {
  colunas: any[];
  linhas: any[];
  loading: boolean;
  totalLinhas: number;
  selecionaLinha?: boolean;
  stringLinhaVazia?: string;
  setPaginacao: (paginacao: GridPaginationModel) => void;
  formasDeListar: number[];
  onRowClick?: (params: GridRowParams<any>) => void;
  getRowId?: GridRowIdGetter<any> | undefined;
  rowHeight?: number;
  pageSize: number;
  paginaAtual: number;
  sx?: any;
  setSortModel?: (gridSortModel: GridSortModel) => void;
  sortModel?: GridSortModel;
};

const TableGeneric: React.FC<Props> = (props) => {
  const {
    colunas,
    linhas,
    loading,
    totalLinhas,
    selecionaLinha,
    stringLinhaVazia,
    setPaginacao,
    formasDeListar,
    onRowClick,
    getRowId,
    rowHeight,
    pageSize,
    paginaAtual,
    sx,
    setSortModel,
    sortModel,
  } = props;

  const classes = useStyles();

  const customLocaleText: Partial<GridLocaleText> = {
    footerRowSelected: (count) =>
      selecionaLinha ? `${count} Linha selecionada` : "",
    noRowsLabel: stringLinhaVazia
      ? stringLinhaVazia
      : "Nenhum registro encontrado",
    MuiTablePagination: {
      labelRowsPerPage: "Linhas por página",
    },
  };

  return (
    <Grid item xs={12} className={classes.root}>
      <DataGrid
        sx={{
          minHeight: 400,
          height: Math.min(linhas.length * 52 + 120, 600),
          borderRadius: 2,
          backgroundColor: "#fff",
          fontFamily: "Roboto, sans-serif",
          position: "relative",

          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f5f5f5",
            color: "#333",
            fontWeight: "600",
            fontSize: "0.95rem",
            borderBottom: "1px solid #e0e0e0",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "0.9rem",
            color: "#444",
            padding: "12px 8px",
            borderBottom: "1px solid #f0f0f0",
          },
          "& .MuiDataGrid-overlay": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            width: "100%",
            backgroundColor: "#fff",
            color: "#777",
            fontSize: "1rem",
          },
        }}
        columns={colunas}
        rows={linhas}
        loading={loading}
        getRowId={getRowId ? getRowId : (value) => value.id}
        rowCount={totalLinhas}
        pagination
        paginationMode="server"
        rowHeight={rowHeight}
        disableColumnFilter
        disableColumnSelector
        disableVirtualization={false}
        disableDensitySelector
        disableColumnMenu
        sortingMode="server"
        sortModel={sortModel}
        onSortModelChange={(model) => {
          if (setSortModel) setSortModel(model);
        }}
        components={{
          Pagination: CustomPaginationActions,
        }}
        componentsProps={{
          pagination: {
            count: totalLinhas,
            page: paginaAtual,
            rowsPerPage: pageSize,
            pageSizeOptions: formasDeListar,
            onChangeLinhasPorPagina: (newPageSize: number) => {
              setPaginacao({ page: 0, pageSize: newPageSize });
            },
          } as any,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize } },
        }}
        onPaginationModelChange={(model) => {
          setPaginacao({
            page: model.page,
            pageSize: model.pageSize,
          });
        }}
        onRowClick={(params) => {
          if (onRowClick) onRowClick(params);
        }}
        localeText={customLocaleText}
      />
    </Grid>
  );
};

export default TableGeneric;

const useStyles = makeStyles({
  root: {
    "& .MuiDataGrid-root": {
      border: "none",
    },
  },
});
